<div>
  <table class="timeline">
    <thead>
      <th class="timeline-line"></th>
      <th class="timeline-date">Date</th>
      <th class="timeline-date">Fulfillment Date</th>
      <th class="timeline-event">Event</th>
    </thead>
    <tbody>
      @for (event of events; track event) {
        <tr class="timeline-row">
          <td class="line">
            <div
            [ngClass]="{
              'hollow-dot': !event.isFulfilled
            }"
              class="dot"
            ></div>
          </td>
          <td>{{ event.startDate | momentFormat }}</td>
          <td>
            @if (event.fulfilledDate) {
              <span>{{ event.fulfilledDate | momentFormat }}</span>
            }
            @if (!event.fulfilledDate) {
              <span>
                @if (event.link) {
                  <a [routerLink]="event.link">Add date</a>
                }
                @if (!event.link) {
                  <span>-</span>
                }
              </span>
            }
          </td>
          <td><span [innerHTML]="event.htmlText"></span></td>
        </tr>
      }
    </tbody>
  </table>
</div>
